'use strict'
import moment from 'moment';
import Currency from './currency.js';

// Change currency code to current symbol
function formatCurrency(price) {
    const code = price[0] + price[1] + price[2];
    const symbol = Currency[code];
    return symbol + Math.round(Number(price.replace(code, ''))).toLocaleString();
}

// Format and return the time appropriately into standard time
function formatTime(data) {
    const date = data.substring(0, data.indexOf('T'));
    let time = data.substring(data.indexOf('T') + 1, data.length);
    time = (time.indexOf('-') > 0) ? 
        time.substring(0, time.indexOf('-')) : time.substring(0, time.indexOf('+'));

    return {
        time: moment(time, 'HH:mm').format('h:mm A'),
        date: moment(date, 'YYYY-MM-DD').format('ddd, MMM D')
    };
}

// Formats the connection time from minuntes to hours and minutes if necessary
function formatConnectionTime(time) {
	if(time%60 === 0) return time/60 + ' hours';
	else if(time > 59) return Math.floor(time/60) + ' hours ' + time%60 + ' mins'	
	else return time + ' mins';
}

export { formatCurrency, formatTime, formatConnectionTime }



// WEBPACK FOOTER //
// ./util/formats.js